import React, { useMemo } from 'react';

import { FolderType, GetOrganizationItemsParams } from '@/api/generated';

import CreateFolderModal from './CreateFolderModal';
import CreateSubFolderModal from './CreateSubFolderModal';
import CreateSubOrganizationModal from './CreateSubOranizationModal';

interface CreateOrganizationModalProps {
  isOpen?: boolean;
  onClose: () => void;
  currentFilter?: GetOrganizationItemsParams | null;
  type?: FolderType;
  locationSlug?: string | null;
  organizationSlug?: string;
  draftItemSlug?: string | null;
}

const CreateOrganizationItemModal: React.FC<CreateOrganizationModalProps> = ({
  isOpen = true,
  onClose,
  type,
  locationSlug,
  organizationSlug,
  currentFilter,
  draftItemSlug
}) => {
  const props = useMemo(
    () => ({
      isOpen,
      onClose,
      locationSlug,
      organizationSlug,
      currentFilter,
      draftItemSlug
    }),
    [isOpen, onClose, locationSlug, organizationSlug, currentFilter, draftItemSlug]
  );

  if (type === FolderType.SUB_ORGANIZATION) {
    return <CreateSubOrganizationModal {...props} />;
  }

  if (type === FolderType.FOLDER) {
    return <CreateFolderModal {...props} />;
  }

  if (type === FolderType.SUB_FOLDER) {
    return <CreateSubFolderModal {...props} />;
  }

  return null;
};

export default CreateOrganizationItemModal;
